import { useNavigate, UseNavigateResult } from '@tanstack/react-router';
import { ASSET_ROUTE_URL } from '../../../constants/routes';
import { ButtonTabs } from '../../ButtonTabs/ButtonTabs';
import { useTradeFormStore } from './TradeFormState';

const tabs = [
  { value: 'long', label: 'Long' },
  { value: 'short', label: 'Short' },
] as const;

export const TradeFormSideTabsUi: React.FC<{
  navigate: UseNavigateResult<typeof ASSET_ROUTE_URL>;
}> = ({ navigate }) => {
  const side = useTradeFormStore((x) => x.side);
  const setSide = useTradeFormStore((x) => x.setSide);

  return (
    <ButtonTabs
      tabs={tabs}
      className="w-full"
      activeTabValue={side}
      onChange={(side) => {
        setSide(side, () => {
          void navigate({ search: (prev) => ({ ...prev, side }) });
        });
      }}
      getBackgroundColor={(activeTab) => {
        return activeTab.value === 'long' ? 'bg-contentGreen' : 'bg-contentRed';
      }}
    />
  );
};

export const TradeFormSideTabs = () => {
  const navigate = useNavigate({ from: ASSET_ROUTE_URL });
  return <TradeFormSideTabsUi navigate={navigate} />;
};
